import { SEZIONE_ACQUISTI, SEZIONE_VETRINA } from './prodottiZone'

// Percorsi aperti a più sezioni (per titolo): basta averne una. La usano il controllo di navigazione e il menù.
export const PERCORSI_CONDIVISI = { '/prodotti': [SEZIONE_ACQUISTI, SEZIONE_VETRINA] }

// Sottopagine di un percorso condiviso riservate a una sola sezione (per titolo): le categorie sono della Vetrina
export const PERCORSI_RISERVATI = { '/prodotti/categorie': SEZIONE_VETRINA }

// La sezione è dell'utente, oppure il suo percorso è condiviso con una sezione dell'utente.
export function sezioneConsentita (sezione, tutte, mie) {
  const sue = mie || []
  if (sue.includes(sezione._id)) return true
  const titoli = PERCORSI_CONDIVISI[sezione.path]
  return !!titoli && tutte.some(s => titoli.includes(s.title) && sue.includes(s._id))
}

// Una pagina è consentita se il suo percorso non appartiene a nessuna sezione, oppure appartiene a una sezione
// consentita all'utente. `tutte`: tutte le sezioni (da /sezioni); `mie`: gli id delle sezioni dell'utente.
// Controllo solo di navigazione: i dati li protegge il BE.
export function percorsoConsentito (pathname, tutte, mie) {
  if (!tutte) return true
  const riservato = Object.keys(PERCORSI_RISERVATI).find(p => pathname === p || pathname.startsWith(`${p}/`))
  if (riservato) return tutte.some(s => s.title === PERCORSI_RISERVATI[riservato] && (mie || []).includes(s._id))
  const sezione = tutte.find(s => pathname === s.path || pathname.startsWith(`${s.path}/`))
  return !sezione || sezioneConsentita(sezione, tutte, mie)
}
